import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'

/**
 * A simple selector which returns all of the data available in the Cube domain.
 * @returns
 */
export const useCubeData = () => {
  const ctx = useCubeContext()

  return {
    data: ctx.queries.rawData.data
  }
}
